var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowLeft = function SvgArrowLeft(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.825 13 4.9 4.9q.3.3.287.7-.012.4-.312.7-.3.276-.7.287a.92.92 0 0 1-.7-.287l-6.6-6.6a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 4.425 12q0-.2.062-.375A.9.9 0 0 1 4.7 11.3l6.6-6.6a.93.93 0 0 1 .688-.275q.412 0 .712.275.3.3.3.713 0 .412-.3.712L7.825 11H19q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 19 13z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };